/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types*/
export const isDate = (date: any): boolean => {
  return null != date && !isNaN(date) && 'undefined' !== typeof date.getDate;
};
